__webpack_require__.p = "/cardy/";